// M-147: 「未返信」判定の純関数（顧客一覧のバッジ / フィルタ / 件数と、functions の更新条件で共有）。
//
// 真実源は `users` の 2 時刻（`lastInboundAt` / `lastReplyAt`）。一覧から `line_events` を
// 集計しない（顧客数 × 購読は重い）。判定は「顧客の最終受信の方が新しい」だけ。
/**
 * `lastReplyAt` を進める送信経路。**自動配信は含めない**（ユーザー確定 2026-09-26）。
 * 人が返した / システムが顧客の発言に応答した、と言えるものだけ。
 */
export const LINE_REPLY_ORIGINS = [
    'admin_chat',
    'webhook_reply',
    'booking_manual_push',
];
export function countsAsReply(origin) {
    return LINE_REPLY_ORIGINS.includes(origin);
}
/** 顧客の最終受信が、こちらの最終返信より新しい（= 返事をしていない）。 */
export function isAwaitingReply(u) {
    if (!u.lastInboundAt)
        return false;
    if (!u.lastReplyAt)
        return true;
    return u.lastInboundAt > u.lastReplyAt;
}
/**
 * 未返信のまま経過した日数（JST 日付差 / 当日 = 0）。`isAwaitingReply` が false なら null。
 * `nowIso` は JST ISO8601（`YYYY-MM-DD...`）。日付部分だけで数える（時刻の丸めで揺れない）。
 */
export function awaitingReplyDays(u, nowIso) {
    if (!isAwaitingReply(u) || !u.lastInboundAt)
        return null;
    const from = Date.UTC(Number(u.lastInboundAt.slice(0, 4)), Number(u.lastInboundAt.slice(5, 7)) - 1, Number(u.lastInboundAt.slice(8, 10)));
    const to = Date.UTC(Number(nowIso.slice(0, 4)), Number(nowIso.slice(5, 7)) - 1, Number(nowIso.slice(8, 10)));
    return Math.max(0, Math.round((to - from) / 86_400_000));
}
/** バッジ文言（`未返信` / `未返信 · 3 日`）。 */
export function awaitingReplyLabel(u, nowIso) {
    const days = awaitingReplyDays(u, nowIso);
    if (days === null)
        return null;
    return days === 0 ? '未返信' : `未返信 · ${days} 日`;
}
export function countAwaitingReply(users) {
    return users.reduce((n, u) => n + (isAwaitingReply(u) ? 1 : 0), 0);
}
//# sourceMappingURL=chatReply.js.map